// Keeps the sidebar and header mounted across page navigations
// so they don't remount on every route change (prevents visual flickering).
// Wraps the non-BLS routes in App.js.
import React, { createContext, useContext } from "react";
import HeaderSidebar from "./Common/HeaderSidebar/HeaderSidebar";
import { useCurrentWebsite } from "@/hooks/useCurrentWebsite";
import { useUserDetails } from "@/contextApi";

const DashboardShellContext = createContext({ hasPersistentSidebar: false });

export const useDashboardShell = () => useContext(DashboardShellContext);

const PersistentDashboardShell = ({ children }) => {
  const { isGitchaDefaultWebsite } = useCurrentWebsite();
  const { isUserLoggedIn } = useUserDetails();

  // Only render persistent sidebar for tenant sites (not default Gitcha)
  if (isGitchaDefaultWebsite) {
    return (
      <DashboardShellContext.Provider value={{ hasPersistentSidebar: false }}>
        {children}
      </DashboardShellContext.Provider>
    );
  }

  // Hide sidebar on tenant login page when user is not authenticated
  const showSidebar = isUserLoggedIn;

  return (
    <DashboardShellContext.Provider value={{ hasPersistentSidebar: showSidebar }}>
      {showSidebar && <HeaderSidebar />}
      {children}
    </DashboardShellContext.Provider>
  );
};

export default PersistentDashboardShell;
